import {cycleCssClasses} from "../../utils";
import {sleepPromise} from "mu-js-utils/lib/utils";
import {Activity, JournalActivity, MyJournal} from "../../types";
import {UiEditActivity} from "./UiEditActivity";
import {DataStore, dataStore} from "../../DataStore";
import {UiJournalActivityList} from "./UiJournalActivityList";
import {Triggers} from "mu-js-utils/lib/Triggers";
import {TNames} from "../../TNames";
import {UiNotifyBanner} from "./UiNotifyBanner";
import {MuRouter} from "mu-widget/lib/MuRouter";
import {frontRouter, setupFrontRouter} from "../../FrontRouter";
import {UiAddActivity} from "./UiAddActivity";
import {AppServiceWorker} from "../../AppServiceWorker";
import {serverConfig} from "../../ServerConfig";
import {EnergyUnit, frontAppConfig} from "../../FrontAppConfig";
import {BaseAppWidget} from "./BaseAppWidget";
import {setupAppPanel} from "../../appPanel";
import {UiFlashContainer} from "mu-widget/lib/components/UiFlash";
import {UiAppClientDataBanner} from "./UiAppClientDataBanner";

export class UiApp extends BaseAppWidget
{
	// @ts-ignore
	public signUrl: string;
	// @ts-ignore
	public urlPrefix: string;
	private router: MuRouter = new MuRouter();
	private addActivityWidget: UiAddActivity|null = null;
	// @ts-ignore
	public webPushPublicKey: string;
    public clientDataIsSet: boolean = true;
    public energyUnit: EnergyUnit = 'kcal';


	bTick_click() {
		AppServiceWorker.call('tick');
	}

	beforeIndex() {
		this.container.classList.add("l-main", "overlay-loader");
		this.muAppendContent(this.hcHeader()
			+ `<div class="l-app-content" mu="content"></div>
			<div class="l-app-bar" mu="bar">
				<a class="icon-size--2rem icon--profile cursor-pointer" mu="bMenu"></a>
				<div mu=":UiNutriInfoPanel"></div>
				<span mu="pBarMiddle"></span>
				<a class="icon-size--2rem icon--plus cursor-pointer" mu="bAdd"></a>
			</div>	
			<div class="l-app-panel" mu="panel">
				<div class="l-app-panel-header">
					<span class="l-app-panel-header__title" mu="panelTitle">Fitnotes</span>
					<span class="l-app-panel-header__buttons" mu="buttons">
						<span class="icon--close" mu="bPanelClose"></span>
					</span>
				</div>		
				<div mu="panelContent" class="l-app-panel-content">
				</div>		
			</div>
		`);
		this.router = frontRouter;
		setupFrontRouter(this);
        /* Triggers.addHandler(TNames.dayLoaded, (data, journal: MyJournal) => {

        }); */
	}

	bDarkLight_click() {
		this.setColorTheme('next');
	}

	async setColorTheme(theme: 'next'|'auto'|'dark'|'light') {
		const newTheme = cycleCssClasses(
			document.querySelector('html')!,
			['theme-auto', 'theme-light', 'theme-dark'],
			theme === 'next' ? null : 'theme-' + theme,
		).substring(6);
		await frontAppConfig.ready;
		if (newTheme !== frontAppConfig.theme) {
			// @ts-ignore
			frontAppConfig.theme = newTheme;
			await frontAppConfig.saveConfig();
		}
	}

	public openPanel(state: boolean = true) {
		this.ui.panel.classList.toggle("l-app-panel--close", !state);
	}

	public get isPanelOpen(): boolean {
		return !this.ui.panel.classList.contains("l-app-panel--close");
	}

	protected widgetDay: UiJournalActivityList|null = null;

	async afterIndex() {
		await frontAppConfig.ready;
		frontAppConfig.applyVisual();
        if (frontAppConfig.energyUnit !== this.energyUnit) await frontAppConfig.updateAndSaveConfig({energyUnit: this.energyUnit});
		serverConfig.webPushPublicKey = this.webPushPublicKey;
		if (this.ui.startLoader) this.muVisible(false, 'startLoader');
		this.openPanel(false);
		const res = await DataStore.get().getCurrentUser();
		if (!res) {
			this.muVisible(false, "bar");
			this.ui.content.innerHTML = '';
			this.muCreateWidget<UiEditActivity>('UiNotLoggedInfo', 'content');
		} else {
			this.widgetDay = this.muCreateWidget<UiJournalActivityList>('UiJournalActivityList', 'content');
			Triggers.dispatch(TNames.logged);
            //
            if (!this.clientDataIsSet) this.openClientDataDialog();
            // Notifikace
			UiNotifyBanner.openDialogIfNeeded();
		}
		setInterval(
			() => Triggers.dispatch(TNames.Minute),
			60000
		);

		this.container.classList.remove("overlay-loader");

		this.router.route(
			document.location.href === this.urlPrefix ? '/' : document.location.href
		);

		navigator.serviceWorker.addEventListener('message', (event) => {
			// addFlash('Zpráva z SW ' + JSON.stringify(event.data));
			// console.log(event.data);
			if (event.data === 'reloadDay') {
			this.widgetDay?.loadJournalActivityList();
			}
		});

		setupAppPanel(this);
	}

	async bPanelClose_click() {
        this.router.navPushSet('day' /*, { day: this.router.lastParameters.day }*/);
		await this.closePanel();
	}

	public async closePanel() {
		this.openPanel(false);
		await sleepPromise(200);
		this.ui.panelContent.innerHTML = "";
		this.addActivityWidget = null;
	}

	openAddMenu(): Promise<void> {
		if (!this.addActivityWidget) {
			this.addActivityWidget = this.muCreateWidget<UiAddActivity>('UiAddActivity', 'panelContent');
			this.openPanel(true);
		}
		return this.addActivityWidget.muInitialized;
	}

	bAdd_click() {
		this.router.navPushSet('newJournalActivity');
	}

	bMenu_click() {
		this.muCreateWidget('UiMenu', 'panelContent');
		this.openPanel(true);
	}

	async editActivity(activity: Activity|null|number, journalActivity: JournalActivity|null|number = null) {
		const w = this.muCreateWidget<UiEditActivity>('UiEditActivity', 'panelContent');
		if (typeof activity === 'number') activity = await dataStore.getActivity(activity);
		if (typeof journalActivity === 'number') journalActivity = await dataStore.getJournalActivity(journalActivity);
		if (journalActivity) {
			w.edit(journalActivity);
		} else {
			w.create(activity!);
		}
		this.openPanel(true);
	}

	/* bProfile_click() {
		redirect(this.signUrl);
	} */

	async selectNewActivity(activityId: number) {
		await this.openAddMenu();
		// @ts-ignore
		this.addActivityWidget?.setActivity(await dataStore.getActivity(activityId));
	}

    async openClientData() {
		await this.closePanel();
		this.muCreateWidget('UiClientData', 'panelContent');
		this.openPanel(true);
	}

    public openClientDataDialog(): void {
        const flash = UiFlashContainer.add('');
        flash.closeTimer.stop();
        flash.muCreateWidget<UiAppClientDataBanner>(
            'UiAppClientDataBanner',
            'message',
            { flashMessage: flash },
        );
    }

    async visualSetup_click() {
        await this.closePanel();
        this.muCreateWidget('UiVisual', 'panelContent');
        this.openPanel(true);
    }
}